class Navigation {
	constructor() {
		this.initialized = false;
		this.navigationMenus = [];
	}

	init() {
		if (this.initialized) {
			return;
		}

		this.navigationMenus = document.querySelectorAll('.bricks-nav-menu');

		if (this.navigationMenus.length) {
			this.registerAnchorHandler();
		}

		this.initialized = true;
	}

	registerAnchorHandler() {
		this.navigationMenus.forEach((navigationMenu) => {
			navigationMenu.addEventListener('click', (event) => {
				const anchor = event.target.closest(
					'a[data-brx-anchor="true"]'
				);

				if (!anchor || !navigationMenu.contains(anchor)) {
					return;
				}

				this.closeAllOpenMobileMenus();
			});
		});
	}

	closeAllOpenMobileMenus() {
		const closeButtons = document.querySelectorAll(
			'.brxe-nav-menu .bricks-mobile-menu-toggle[aria-expanded="true"]'
		);

		closeButtons.forEach((closeButton) => {
			closeButton.click();
		});
	}
}

export const navigation = new Navigation();
